import {
  useDistributorTypeQuery,
  UseDistributorTypeQueryParams,
} from "../queries/useDistributorType.query";
import { IPagination } from "../../../interfaces/IPagination";
import { TDistributorType } from "../types/distributorTypes.types";

type Response = {
  distributorTypes: TDistributorType[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useDistributorTypes = (
  opt: UseDistributorTypeQueryParams,
): Response => {
  const { data, isLoading } = useDistributorTypeQuery(opt);
  return {
    distributorTypes: data?.data?.distributorTypes || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
